import button from '../button/button'

export default function(o){

  var getIcon = function(){
    if(o.store('soundOff')){
      var icon = 'soundOff'
    } else {
      var icon = 'soundOn'
    }
    return icon
  }

  var icon = getIcon()

  var toggle = function(){
    if(o.store('soundOff')){
      o.store('soundOff', false)
      if(o.sequenceIsPlaying){
        o.util.soundPlay(o,0)
      }
    } else {
      o.store('soundOff',true)
      o.util.soundStop(o,0)
    }
    div.setIcon(getIcon())
  }

  var div =
    button(o, o.util.getTranslation(o, 'sound'), toggle, icon, true)

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/sound/sound.js